"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Tooltip = (props) => {
    const { title, placement = "bottom-start", children, ...rest } = props;
    return (react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "center" },
        react_1.default.createElement(material_1.Grid, { item: true },
            react_1.default.createElement(material_1.Tooltip, { title: title, arrow: true, placement: placement, ...rest },
                react_1.default.createElement("div", null, children)))));
};
exports.default = Tooltip;
